module.exports = "<div class=q-time-picker-default> <div class=time-picker-hours-select-outer> <select class=time-picker-hours-select> </select> </div> <span class=time-picker-seperater>:</span> <div class=time-picker-minutes-select-outer> <select class=time-picker-minutes-select> </select> </div> <div class=time-picker-period-select-outer> <select class=time-picker-period-select> </select> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/timePicker/html/timePickerTemplate.html
// module id = 1173
// module chunks = 1